import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProcedureTypeDetailViewTopBar } from "./TopBar"

export const procedureTypeDetailViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProcedureTypeDetailViewTopBar,
}
